import { resetERAReportItems } from '../../../../packages/neb-api-client/src/era-report-api-client';

export default ({ model: { id: eraId }, claimReportId, lineItemReportId }) =>
  resetERAReportItems({
    eraId,
    claimReportId,
    lineItemReportId,
  });
